import React, { FC } from "react";
import style from "./Section.scss";

export interface SectionProps {

}

export const Section: FC<SectionProps> = props => {
    return (
        <section className={style.section}>
            {props.children}
        </section>
    );
};
